import PropTypes from 'prop-types'
import React from 'react'

import './EmailButton.css'

const EmailButton = ({recipient, subject, body, label="Send email"}) => {
  return (
    <a href={`mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
      className="EmailButton"
      target="_blank">{label}</a>
  )
}

EmailButton.propTypes = {
  label: PropTypes.string,
  recipient: PropTypes.string,
  subject: PropTypes.string,
  body: PropTypes.string
}

export default EmailButton



// WEBPACK FOOTER //
// ./src/EmailButton.js